import { MultiSelect } from '@mantine/core';
import { uniq } from 'lodash';

export default function Filters({
	data,
	searchValue,
	setSearchValue,
	typeField = 'Type',
	typeValue,
	setTypeValue,
	useValue,
	setUseValue,
}) {
	return (
		<div className='tw-grid sm:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-x-4 tw-gap-y-2 tw-mb-6'>
			<MultiSelect
				label='Filter by Name'
				placeholder='Type to search'
				searchable
				clearable
				data={uniq(
					data
						.map((item) => [
							item.Label && {
								value: item.Label,
								label: item.Label,
								group: 'Language Name',
							},
							item.CommonName && {
								value: item.CommonName,
								label: item.CommonName,
								group: 'Common Name',
							},
						])
						.filter((x) => x.length > 0)
						.flat()
				)}
				value={searchValue}
				onChange={setSearchValue}
				styles={{
					searchInput: { margin: '0 !important' },
				}}
			/>
			<MultiSelect
				label={`Filter by ${typeField.replace(/([a-z])([A-Z])/g, '$1 $2')}`}
				data={uniq(data.map((item) => item[typeField]?.split(';')).flat())
					.filter((x) => !!x)
					.map((item) => ({ value: item, label: item }))}
				placeholder='Type to search'
				searchable
				clearable
				value={typeValue}
				onChange={setTypeValue}
				styles={{
					searchInput: { margin: '0 !important' },
				}}
			/>
			<MultiSelect
				label='Filter by Uses'
				data={uniq(data.map((item) => item.Uses?.split(';')).flat())
					.filter((x) => !!x)
					.map((item) => ({ value: item, label: item }))}
				placeholder='Type to search'
				searchable
				clearable
				value={useValue}
				onChange={setUseValue}
				classNames={{
					root: 'md:tw-col-span-2 xl:tw-col-span-1',
				}}
				styles={{
					searchInput: { margin: '0 !important' },
				}}
			/>
		</div>
	);
}
